'use client'

import { useTranslation } from "@theme/base/contexts"
import PageTitle from "../Common/PageTitle"

const DeliveryNotesListTitle = () => {
    const { getTranslation } = useTranslation()
    return <PageTitle title={getTranslation("page.title.deliverynotes")} />
}

export default DeliveryNotesListTitle